module.exports = __webpack_public_path__ + "img/JS.75c3abfa.png";